export class CreditCategory {
    public id : number = -1;
    public name : string = '';
    public revenueCode : string = '';
}